/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChevronsUp = createReactComponent("outline", "chevrons-up", "IconChevronsUp", [["path", { "d": "M7 11l5 -5l5 5", "key": "svg-0" }], ["path", { "d": "M7 17l5 -5l5 5", "key": "svg-1" }]]);

export { IconChevronsUp as default };
//# sourceMappingURL=IconChevronsUp.mjs.map
